import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { getCommunityLogoUrl, getCommunityDisplayName } from "Utils";

export default class Community extends PureComponent {
  static propTypes = {
    community: PropTypes.object,
    onClick: PropTypes.func
  };

  render() {
    const { community, onClick, nbColumns, asCard } = this.props;

    return (
      <div
        className={`${asCard ? "card" : ""} sc__community cell small-${
          nbColumns ? 12 / nbColumns : 4
        }`}
        onClick={onClick}
      >
        <div className="sc__community-logo">
          <img src={getCommunityLogoUrl(community)} alt={community.name} />
        </div>
        <span className="sc__community-name" title={community.name}>
          {getCommunityDisplayName(community)}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectCommunity/Community.js